import ListIcon from './component'

export default ListIcon
